<template>
  <div >
    <div class="report-wrap">
      <div class="title">选择你遇到的问题</div>
    <div class="ques-box">
      <div class="ques-item" v-for="(item, index) in lists" :key="index" @click="toComplain(item.value)">
        <span>{{ item.title }}</span>
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
          alt=""
        />
      </div>
    </div>
    </div>
    
  </div>
</template>
<script>
import {complainLists
} from "@/utils/config";

export default {
  data() {
    return {
      lists: complainLists,
      order_id: ''
    };
  },
  methods: {
    toComplain(name_id) {
      this.$router.replace({ name: "complain", query: {no: this.order_id, name: name_id} });
    }
  },
  mounted() {
    document.title = '投诉'
    if(this.$route.query.no) {
      this.order_id = this.$route.query.no;
      if(this.$route.query.ut) {
        localStorage.setItem("token", this.$route.query.ut);
        this.$router.replace({
          name: 'report',
          query: {
            no: this.$route.query.no
          }
        })
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.report-wrap {
  background: #ffffff;
  padding: 0 15px;
}
.title {
  font-size: 17px;
  font-weight: bold;
  padding: 15px 0;
}
.ques-box {
  background: #ffffff;
  margin-top: 5px;
}
.ques-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  height: 55px;
  border-top: 1px solid #EEEEEE;
  cursor: pointer;
  padding: 0;
  img {
    width: 8px;
    height: 12px;
  }
}
.ques-item:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/report.vue